import React, { CSSProperties, ReactNode } from "react";
import { ContentContainer, ContentContainer2 } from "./Container";

import { SerializedStyles } from "@emotion/react";

import cn from "classnames";

export const WrapperComponent = (props: {
  width: "full" | "content" | "content-but-full-on-small";
  children: ReactNode;
  attachStyles?: SerializedStyles;
}) =>
  props.width === "full" ? (
    <React.Fragment>{props.children}</React.Fragment>
  ) : props.width === "content" ? (
    <ContentContainer attachStyles={props.attachStyles}>{props.children}</ContentContainer>
  ) : (
    <ContentContainer2 attachStyles={props.attachStyles}>{props.children}</ContentContainer2>
  );

export const WrapperComponentWithDiv = (props: {
  width: "full" | "content";
  children: ReactNode;
  attachStyles?: SerializedStyles | Array<SerializedStyles>;
  className?: string;
  style?: CSSProperties;
}) =>
  props.width === "full" ? (
    <div className={cn("wrapper", props.className)} css={props.attachStyles} style={props.style}>
      {props.children}
    </div>
  ) : (
    <ContentContainer className={props.className} attachStyles={props.attachStyles} style={props.style}>
      {props.children}
    </ContentContainer>
  );
